export default {
  // Higher than dropdown: 1000, but lower than sticky (nav)
  // https://v1.chakra-ui.com/docs/styled-system/theming/theme?scroll=true#z-index-values
  tooltip: 1001,
};
